<template>
    <div v-if="program">
        <v-layout row wrap justify-center align-start>
            <v-flex xs12 md12 lg12>
                <v-card min-height="500px">
                    <v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                           <EventLinkDialog
                            :program.sync="program"
                            @update="$emit('update')"
                            ></EventLinkDialog>
                        </v-card-actions>
                        <v-card-title class="grey lighten-3">
                            <v-flex xs12 md6 lg8 class="px-2">
                                <h3> {{  $t("program.event.link_events") }}</h3>

                            </v-flex>
                            <v-flex xs12 md6 lg4 class="px-2">
                                <v-text-field v-model="search" append-icon="search" label="Search" outline
                                hide-details></v-text-field>
                            </v-flex>

                        </v-card-title>
                        <v-data-table
                            :headers="tableHeaders"
                            :items="filteredScreeners"
                            v-bind:pagination.sync="pagination"
                            :total-items="program.screeners.length"
                            :rowsPerPageItems="[20, 50, 100]"

                        >
                            <template v-slot:items="props">
                                <td class="text-xs-left subheading">{{ props.item.id }}</td>
                                <td class="pa-3">
                                    <v-img
                                        v-if="props.item.thumbnail_url"
                                        :src="props.item.thumbnail_url"
                                        contain
                                    ></v-img>
                                </td>
                                <td class="text-xs-left">{{
                                    props.item.title[$i18n.locale] ||
                                    props.item.title.en ||
                                    ""
                                  }}</td>
                                <td class="text-xs-left">{{ fmtTime(props.item.screening_starts_at) }}</td>
                                <td class="text-xs-left">{{ fmtTime(props.item.screening_ends_at) }}</td>
                                <td>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" @click="unlinkScreener(props.item)" small icon>
                                                <v-icon color="error">mdi-close</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>{{ $t('program.page.events.link.dialog.unlink.btn.tooltip') }}</span>
                                    </v-tooltip>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import i18n from "@/i18n";
import EventLinkDialog from "@/pages/program/_programId/EventLinkDialog";
import { utcToTz } from "@/helper";
import { mapGetters } from 'vuex';
import momentTz from 'moment-timezone';

export default {
    name: 'Events',
    props: {
        program: {
            type: Object,
            default: null,
        },
    },
    components:{EventLinkDialog},
    data() {
        return {
            tableHeaders: [
                {
                    text: i18n.t("progrom.events.table.header.s.n"),
                    align: "left",
                    sortable: false,
                    value: "logo",
                },
                {
                    text: i18n.t("progrom.events.table.header.thumbnail"),
                    align: "left",
                    value: ""
                },
                {
                    text: i18n.t("progrom.events.table.header.title"),
                    align: "left",
                    value: ""
                },
                {
                    text: i18n.t("progrom.events.table.header.start_date"),
                    align: "left",
                    sortable: true,
                    value: "",
                },

                {
                    text: i18n.t("progrom.events.table.header.end_date"),
                    align: "left",
                    sortable: true,
                    value: "title",
                },
                {
                    text: i18n.t("progrom.events.table.header.action"),
                    align: "left",
                    sortable: false,
                },
            ],
            search: '',
            pagination: {
                sortBy: "created_at",
                descending: true,
                page: 1,
                rowsPerPage: 20,
                perPage: 20,
                totalItems: 0,
            },

        };
    },
    computed: {
        ...mapGetters('company', {
            timezone: 'getSelectedCompanyTimezone',
            company: 'getSelectedCompany'
        }),
        linkedScreenerIds() {
            if(!this.program || !this.program.screeners.length){
                return []
            }

            return this.program.screeners.map((screener) => screener.id)
        },

        filteredScreeners() {
            if (!this.search) {
                return this.program.screeners;
            }
            const searchTerm = this.search.toLowerCase();
            return this.program.screeners.filter(screener => {
                return screener.title.toLowerCase().includes(searchTerm);
            });
        }
    },
    methods: {
        fmtTime(input) {
            if (input && this.company) {
                // OS local timezone
                var timezone = momentTz.tz.guess(true);
                return utcToTz(input, timezone, "MMMM Do YYYY, h:mm a");
            }
        },

        unlinkScreener(screener) {
            let screenerIds = Object.assign([], this.linkedScreenerIds)
            let index = screenerIds.indexOf(screener.id)

            if(index != -1){
                screenerIds.splice(index, 1);
            }

            this.program.screener_ids = screenerIds
            this.$emit('update')
        }
    }

}
</script>
